import { render, staticRenderFns } from "./concept.vue?vue&type=template&id=6ad7ee64&scoped=true&"
import script from "./concept.vue?vue&type=script&lang=js&"
export * from "./concept.vue?vue&type=script&lang=js&"
import style0 from "./concept.vue?vue&type=style&index=0&id=6ad7ee64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad7ee64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
